import { updateNotificationContactThunk } from './updateNotificationContactThunk';
export default updateNotificationContactThunk;
